/* Info component on the Scene Component */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Scene.module.css";

const InfoScenePage = () => {
  return (
    <div>
      <Row className="mb-3">
        <Col md={{span: 10, offset: 1}}>
        <div className={`px-3 py-2 ${styles.SubTitle6}`}>
          <p className={`${styles.Red} text-center`}>SCENE PAGE</p>
          <hr className={`mt-2 mb-0`}/>
          <p className="pt-2"><span className={`${styles.Red}`}>*</span> The Scene page is the foundation of the Platform workflow.
          </p>
          <p className="pt-2"><span className={`${styles.Red}`}>*</span> Create each Scene's <span className={`${styles.Red}`}>Breakdown</span> and <span className={`${styles.Red}`}>Characters/BG</span> page,
           the basis of this flow.
          </p>
            <p className="pt-2"><span className={`${styles.Red}`}>*</span> Collaborate on Production Items in the Scene by Department in the Scene <span className={`${styles.Red}`}>Workshop</span>, adding 
              them to the Production Tracker.              
            </p>
            <p className="pt-2"><span className={`${styles.Red}`}>*</span> Create each Scene's <span className={`${styles.Red}`}>Shotlist</span>. Click the "Shot/Story" tab to view the Storyboard 
            and Shotlist side by side.
          </p>
            <p className="pt-2"><span className={`${styles.Red}`}>*</span> Add the Scene <span className={`${styles.Red}`}>Storyboard</span> and also optionally 
              the Scene Script.</p>
            <p className="pt-2"><span className={`${styles.Red}`}>*</span> Scene <span className={`${styles.Red}`}>Moodboards</span> can be directly 
            created from the page for
            pre-visualisation.</p>
            <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoScenePage